<template>
    <div class="section" id="projects">
        <main>
            <div class="back" id="backpro"></div>

        <ul>
            <li><a href="https://estateemp.netlify.app/" target="_blank">Real Estate </a></li>
            <li><a href="https://github.com/computerGuy11/a-pathfinding-algo-with-custom-walls-on-vanilla-js" target="_blank">Find your path</a></li>
            <li><a href="https://github.com/computerGuy11/covid-tracker-VueJS" target="_blank">Covid Tracker</a></li>
            <li><a href="https://github.com/computerGuy11/ai-chat-app-in-nodeJS-vueJS" target="_blank">Chat Bot</a></li>

        </ul>
       
    </main>

    </div>
</template>
<script>
    export default {
        name :'Projects',
        mounted(){
            const link = require('@/js/disor2.js')
  const plugin = document.createElement("script");
    plugin.setAttribute(
      "src",
      link
    );
    plugin.async = true;
    document.head.appendChild(plugin);
        }
    }
</script>